<template>
  <Fragment>
    <template v-if="$route.name !== 'user'">
      <router-view></router-view>
    </template>
    <section class="container" v-else>
      <Breadcrumb />
      <div class="card-wrap mt-20 mb-20">
        <section class="card-content">
          <div class="left">
            <div class="search-name mr-15">
              <span>姓名：</span>
              <el-input v-model="realName"> </el-input>
            </div>
            <div class="search-name mr-15">
              <span>工号：</span>
              <el-input v-model="username"> </el-input>
            </div>
            <el-button type="primary" class="ml-20" @click="searchUserInfo"
              >查询</el-button
            >
          </div>
        </section>
      </div>
      <el-table :data="list" style="width: 100%" border>
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">
            <span>{{ scope.$index + (pageNum - 1) * pageSize + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="姓名" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.realName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="工号" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.username }}</span>
          </template>
        </el-table-column>
        <el-table-column label="角色" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.roleName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="职位代码" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.businessPosition }}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.addDate }}</span>
          </template>
        </el-table-column>
        <el-table-column label="用户状态" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.userState === "1" ? "正常使用" : "禁用" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" :fit="true">
          <template slot-scope="scope">
            <el-button size="mini" @click="editUserInfo(scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20 pagination"
        background
        layout="total,prev, pager, next, jumper"
        :total="total"
        :page-size="10"
        :current-page="pageNum"
        @prev-click="handlePrePage"
        @next-click="handleNextPage"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </section>
  </Fragment>
</template>

<script>
import { Fragment } from "vue-fragment";

import Breadcrumb from "@/components/Breadcrumb";
export default {
  name: "user",
  components: {
    Breadcrumb,
    Fragment
  },
  data() {
    return {
      realName: "",
      username: "",
      list: [],
      pageNum: 1,
      pageSize: 10,
      total: 0
    };
  },
  methods: {
    getUserList() {
      let _this = this;
      let param = {
        url: "/api/system/user/getUserList",
        params: {
          realName: _this.realName,
          username: _this.username,
          pageNum: _this.pageNum,
          pageSize: _this.pageSize
        }
      };

      _this.$store.dispatch("getUserList", param).then(() => {
        _this.list = _this.$store.state.system.userList.list;
        _this.total = _this.$store.state.system.userList.total;
      });
    },
    //查询
    searchUserInfo() {
      let _this = this;
      _this.getUserList();
    },
    //当前页
    handleCurrentChange(value) {
      let _this = this;
      _this.pageNum = value;
      _this.getUserList();
    },
    //上一页
    handlePrePage() {
      let _this = this;
      _this.pageNum -= 1;
      _this.getUserList();
    },
    //下一页
    handleNextPage() {
      let _this = this;
      _this.pageNum += 1;
      _this.getUserList();
    },
    //编辑
    editUserInfo(row) {
      this.$router.push({
        name: "userManage",
        params: { id: row.id }
      });
    }
  },
  created() {
    let _this = this;
    _this.getUserList();
  }
};
</script>

<style lang="sass" scoped>
.card-wrap
  .card-content
    display: flex
    align-items: center
    justify-content: space-between
    .left
      display: flex
    .el-button
      font-size: 14px
    .search-name, .search-code
      font-size: 14px
      display: flex
      align-items: center
      span
        white-space: nowrap
.pagination
  text-align: center
</style>
